import BN from "bn.js";
import { PublicKey } from "@solana/web3.js";
import { EscrowAccount } from "../type";

export interface IEscrowWrapper {
  getEscrowAccount(): EscrowAccount;
  getStakingAddress(): PublicKey;
  getOwner(): PublicKey;

  getStakedAmount(): BN;
  getUiStakedAmount(): number;
  getPartialUnstakedAmount(): BN;
  getUiPartialUnstakedAmount(): number;

  isEmpty(): boolean;
  canClose(): boolean;
}

export class EscrowWrapper implements IEscrowWrapper {
  public escrowAccount: EscrowAccount;
  public tokenDecimals: number;
  private multiplier: number;

  constructor(escrowAccount: EscrowAccount, tokenDecimals: number) {
    this.escrowAccount = escrowAccount;
    this.tokenDecimals = tokenDecimals;
    this.multiplier = 10 ** tokenDecimals;
  }

  getEscrowAccount(): EscrowAccount {
    return this.escrowAccount;
  }

  getStakingAddress(): PublicKey {
    return this.escrowAccount.staking;
  }

  getOwner(): PublicKey {
    return this.escrowAccount.owner;
  }

  getStakedAmount(): BN {
    return this.escrowAccount.stakedAmount;
  }

  getUiStakedAmount(): number {
    return this.escrowAccount.stakedAmount.toNumber() / this.multiplier;
  }

  getPartialUnstakedAmount(): BN {
    return this.escrowAccount.partialUnstakedAmount;
  }

  getUiPartialUnstakedAmount(): number {
    return (
      this.escrowAccount.partialUnstakedAmount.toNumber() / this.multiplier
    );
  }

  isEmpty(): boolean {
    return (
      this.escrowAccount.stakedAmount.isZero() &&
      this.escrowAccount.partialUnstakedAmount.isZero()
    );
  }

  canClose(): boolean {
    return this.isEmpty();
  }
}
